// removed by extract-text-webpack-plugin
module.exports = {"root":"_1m0ZbeO","savePrompt":"_2Do1QbF","icon":"_3g5Phg4","saveDescription":"_2kdDSr8"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMail/JobMailWrapper.less
 ** module id = 888
 ** module chunks = 0
 **/